export default __webpack_public_path__ + "static/media/all filter icons in square.220790b1.svg";